// @ts-nocheck
import { buildActions, makeReqCons } from 'store/actions';
import type { ReduxFunction } from 'types/redux';

export const accountConstants = {
  updateYukiSettings: makeReqCons('account_update_yuki'),
  updateHorusSettings: makeReqCons('account_update_horus'),
  updateDbasicsSettings: makeReqCons('account_update_dbasics'),
  updateTeamleaderSettings: makeReqCons('account_update_teamleader'),
  updateExactSettings: makeReqCons('account_update_exact'),
  exactFetchCompanies: makeReqCons('exact_fetch_companies'),
  horusFetchCompanies: makeReqCons('horus_fetch_companies'),
  syncIntegration: makeReqCons('sync_integration'),
  syncIntegrationPdfs: makeReqCons('sync_integration_pdfs'),
  importInvoice: makeReqCons('invoice_import'),
  activityPage: makeReqCons('account_activity_page'),
  activityDetail: makeReqCons('account_activity_detail'),
  activitySeen: makeReqCons('account_activity_seen'),
  activitySeenAll: makeReqCons('account_activity_seen_all'),
  setDigitealConfiguration: makeReqCons('set_digiteal_configuration'),
  getDigitealCGV: makeReqCons('get_digiteal_CGV'),
  getTerms: makeReqCons('GET_ACCOUNT_CGV'),
};

type AccountActions = {
  syncIntegration: ReduxFunction;
  syncIntegrationPdfs: ReduxFunction;
  updateYukiSettings: ReduxFunction;
  updateHorusSettings: ReduxFunction;
  updateDbasicsSettings: ReduxFunction;
  updateTeamleaderSettings: ReduxFunction;
  updateExactSettings: ReduxFunction;
  exactFetchCompanies: ReduxFunction;
  horusFetchCompanies: ReduxFunction;
  importInvoice: Function;
  activityPage: ReduxFunction;
  activityPageRes: Function;
  activityDetail: ReduxFunction;
  activitySeen: ReduxFunction;
  activitySeenRes: Function;
  activitySeenAll: ReduxFunction;
  setDigitealConfiguration: ReduxFunction;
  getDigitealCGV: Function;
  getTerms: Function;
};

// Autogenerated actions according to constants
const accountActions = buildActions<AccountActions>('', accountConstants, {});

export { accountActions };
